export enum SadtStatusEnum {
    Pedido = 1,
    Entregue = 2,
    AguardandoArquivo = 3,
    Suspenso = 4,
}